import { Label, Radio } from "flowbite-react";
import { Control, Controller } from "react-hook-form";
import { ToggleSwitch } from "../../components/form/ToggleSwitch";
import { HorizontalDivider } from "../../components/HorizontalDivider";
import notificationTypes from "../../data/notification-types.json";
import { PushNotificationFormValues } from "./PushNotificationForm.Types";

interface PushNotificationFormStep1Props {
  control: Control<PushNotificationFormValues>;
  formValues: PushNotificationFormValues;
  selectedNotificationType: string;
}

const PushNotificationFormStep1 = ({
  control,
  formValues,
  selectedNotificationType,
}: PushNotificationFormStep1Props) => {
  return (
    <div id="step-1" className="space-y-6">
      <Controller
        name="notificationType"
        control={control}
        rules={{
          required: "Notification type is required",
        }}
        render={({ field, fieldState: { error } }) => (
          <>
            <Label className="block text-sm font-medium mb-2">
              Notification Type <span className="text-red-500">*</span>
            </Label>
            <ul className="flex flex-row flex-nowrap gap-2 justify-center h-30 items-stretch overflow-x-auto">
              {notificationTypes.map((notificationType) => (
                <li
                  key={notificationType.id}
                  className={`flex-1 flex-grow p-4 border rounded-md text-center hover:border-red-500 transition-colors cursor-pointer bg-white ${
                    selectedNotificationType === notificationType.id
                      ? "border-red-500"
                      : "border-gray-200"
                  }`}
                >
                  <Radio
                    name="notificationType"
                    id={notificationType.id}
                    value={notificationType.id}
                    onChange={() => {
                      field.onChange(notificationType.id);
                    }}
                    className="hidden"
                  />
                  <Label
                    htmlFor={notificationType.id}
                    className="cursor-pointer flex flex-col text-left "
                  >
                    <img
                      src={`/images/notification-types/${notificationType.icon}`}
                      alt={notificationType.name}
                      width={40}
                      height={40}
                    />
                    <div className="line-clamp-2 m-1">
                      {notificationType.name}
                    </div>
                  </Label>
                </li>
              ))}
            </ul>
            <p className="text-red-500 text-xs mt-1">{error?.message}</p>
          </>
        )}
      />

      <HorizontalDivider />

      <Controller
        name="sendPushNotification"
        control={control}
        render={({ field, fieldState: { error } }) => {
          const { name, value, onChange } = field;
          return (
            <ToggleSwitch
              name={name}
              onChange={onChange}
              label="Send Push Notification"
              selected={value}
              tooltip="Sends alerts to the user's device. If turned off, notifications will only be visible when they open the app."
            />
          );
        }}
      />

      <Controller
        name="shortTermAnnouncement"
        control={control}
        render={({ field, fieldState: { error } }) => {
          const { name, value, onChange } = field;
          return (
            <ToggleSwitch
              name={name}
              onChange={onChange}
              label="It’s an emergent/short-term announcement"
              selected={value}
              tooltip="Turn this off for time-sensitive messages to set an expiration time. Expired notifications will be removed automatically."
            />
          );
        }}
      />

      <HorizontalDivider />

      <button
        type="submit"
        className="focus:outline-none text-white bg-brand font-medium rounded-md text-md px-5 py-2.5 me-2 mb-2 w-full"
      >
        Next
      </button>
    </div>
  );
};

export default PushNotificationFormStep1;
